import { BaseIndex } from "../BaseIndex";
export class ArrayIndex extends BaseIndex {
    constructor(getSource, transform) {
        super(getSource, transform);
        this.defaultValue = [];
    }
}
//# sourceMappingURL=ArrayIndex.js.map